import { Component, OnInit, OnDestroy, AfterViewInit } from '@angular/core';
import { Subscription, pipe, tap, distinctUntilChanged } from 'rxjs';

import { BreakpointObserver, Breakpoints, BreakpointState } from '@angular/cdk/layout';
import { NavigationEnd, Router } from '@angular/router';
import NavMenuService from '../nav-menu-service';
import { RESPONSIVE_DESKTOP_BREAKPOINT } from 'src/app/models/app-constants';

@Component({
    selector: 'app-nav-menu',
    templateUrl: './nav-menu.component.html',
    styleUrls: ['./nav-menu.component.scss']
})
export class NavMenuComponent implements OnInit, OnDestroy, AfterViewInit {
   
    private breakpointSub: Subscription;
    public mobileMenuVisible: boolean = false;
    private menuServiceSubscription: Subscription;  

    readonly breakpoint$ = this.breakpointObserver.observe(RESPONSIVE_DESKTOP_BREAKPOINT).pipe(tap(value => {      
    }), distinctUntilChanged());


    constructor(private navMenuService: NavMenuService,
        private breakpointObserver: BreakpointObserver,
        private router: Router) {

    }

    ngOnInit(): void {
        this.breakpointSub = this.breakpoint$.subscribe({
            next: (result) => {
                if (result.matches) {
                    this.navMenuService.setActivated(false);
                }
            },
            error: (ex) => {

            },
            complete: () => {

            }
        });


        this.navMenuService.getActivated().subscribe({
            next: (value: boolean) => {
                this.mobileMenuVisible = value;
                if (value) {
                    if (!document.body.classList.contains("main-nav-active")) {
                        document.body.classList.add("main-nav-active");
                    }
                }
                else {
                    if (document.body.classList.contains("main-nav-active")) {
                        document.body.classList.remove("main-nav-active");
                    }
                }
            }
        });

        this.router.events.subscribe({
            next: (val: any) => {
                if (val instanceof NavigationEnd) {
                    if (this.mobileMenuVisible) {
                        this.navMenuService.setActivated(false);
                    }
                }
            }
        });
    }

    ngAfterViewInit(): void {


    }

    ngOnDestroy(): void {
        this.menuServiceSubscription && this.menuServiceSubscription.unsubscribe();
        this.breakpointSub && this.breakpointSub?.unsubscribe();
    }
}
